import { render } from "./RegraForm.vue?vue&type=template&id=445921af"
import script from "./RegraForm.vue?vue&type=script&lang=js"
export * from "./RegraForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__